import { render, staticRenderFns } from "./progress-loading.vue?vue&type=template&id=565142ab&scoped=true"
import script from "./progress-loading.vue?vue&type=script&lang=js"
export * from "./progress-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565142ab",
  null
  
)

export default component.exports